import UIComponent from "../../common/UIComponent";
import { formatSeconds } from "../../common/Utils";
import "./index.css";
export default class playBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.LOADED, () => {
      this.allTime.innerText = formatSeconds(this.interfaces.getDuration())
    })

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {
      this.currentTime.innerText = formatSeconds(this.interfaces.getCurrentTime())
    })

  }

  init() {

    this.timeBox = document.createElement("div");
    this.timeBox.setAttribute("class", "vhallPlayer-time-box");

    // 当前时间
    this.currentTime = document.createElement("span");
    this.currentTime.setAttribute("class", "current-time");
    this.currentTime.innerText = "00:00:00";

    // 分割线
    this.cutLine = document.createElement("i");
    this.cutLine.innerText = "/";

    // 所有时间
    this.allTime = document.createElement("span");
    this.allTime.setAttribute("class", "all-time");
    this.allTime.innerText = "00:00:00";

    this.timeBox.appendChild(this.currentTime);
    this.timeBox.appendChild(this.cutLine);
    this.timeBox.appendChild(this.allTime);

    this.appendChild(this.elementId, this.timeBox);
  }


}